import { render, staticRenderFns } from "./AccountReceivableReport.vue?vue&type=template&id=2fabca34&"
import script from "./AccountReceivableReport.vue?vue&type=script&lang=js&"
export * from "./AccountReceivableReport.vue?vue&type=script&lang=js&"
import style0 from "./AccountReceivableReport.vue?vue&type=style&index=0&id=2fabca34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports